// ======================================================================
// FILE:
// src/modules/service_crm/feedback/components/FeedbackFilterBar.js
//
// MODULE: Service CRM
// FEATURE: Feedback Filters
// ======================================================================

import React, {
  useState,
} from "react";

export default function FeedbackFilterBar({

  filters = {},

  onApply,
}) {

  const [localFilters, setLocalFilters] =
    useState({

      q:
        filters.q || "",

      status:
        filters.status || "",

      engineer:
        filters.engineer || "",

      date_from:
        filters.date_from || "",

      date_to:
        filters.date_to || "",
    });

  const updateField = (
    field,
    value
  ) => {

    setLocalFilters((prev) => ({

      ...prev,

      [field]: value,
    }));
  };

  const applyFilters = () => {

    const cleaned = {};

    Object.keys(
      localFilters
    ).forEach((key) => {

      const value =
        localFilters[key];

      if (
        value !== null &&
        value !== undefined &&
        value !== ""
      ) {

        cleaned[key] = value;
      }
    });

    onApply(cleaned);
  };

  const clearFilters = () => {

    const reset = {

      q: "",

      status: "",

      engineer: "",

      date_from: "",

      date_to: "",
    };

    setLocalFilters(reset);

    onApply({});
  };

  return (

    <div
      style={{
        background: "#fff",
        borderRadius: 14,
        padding: 20,
        marginBottom: 20,
        boxShadow:
          "0 2px 8px rgba(0,0,0,0.08)",
      }}
    >

      <div
        style={{
          fontSize: 16,
          fontWeight: 700,
          marginBottom: 18,
        }}
      >
        Search & Filters
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(250px,1fr))",
          gap: 14,
        }}
      >

        <div>

          <label>
            Search
          </label>

          <input
            type="text"
            value={
              localFilters.q
            }
            onChange={(e) =>
              updateField(
                "q",
                e.target.value
              )
            }
            placeholder="Ticket / Customer"
            style={inputStyle}
          />

        </div>

        <div>

          <label>
            Feedback Status
          </label>

          <select
            value={
              localFilters.status
            }
            onChange={(e) =>
              updateField(
                "status",
                e.target.value
              )
            }
            style={inputStyle}
          >

            <option value="">
              All
            </option>

            <option value="PENDING">
              Pending
            </option>

            <option value="COMPLETED">
              Completed
            </option>

          </select>

        </div>

        <div>

          <label>
            Engineer
          </label>

          <input
            type="text"
            value={
              localFilters.engineer
            }
            onChange={(e) =>
              updateField(
                "engineer",
                e.target.value
              )
            }
            placeholder="Engineer Name"
            style={inputStyle}
          />

        </div>

        <div>

          <label>
            Date From
          </label>

          <input
            type="date"
            value={
              localFilters.date_from
            }
            onChange={(e) =>
              updateField(
                "date_from",
                e.target.value
              )
            }
            style={inputStyle}
          />

        </div>

        <div>

          <label>
            Date To
          </label>

          <input
            type="date"
            value={
              localFilters.date_to
            }
            onChange={(e) =>
              updateField(
                "date_to",
                e.target.value
              )
            }
            style={inputStyle}
          />

        </div>

      </div>

      <div
        style={{
          display: "flex",
          justifyContent:
            "flex-end",
          gap: 10,
          marginTop: 18,
        }}
      >

        <button
          onClick={
            clearFilters
          }
          style={clearButtonStyle}
        >
          Clear
        </button>

        <button
          onClick={
            applyFilters
          }
          style={applyButtonStyle}
        >
          Apply Filters
        </button>

      </div>

    </div>
  );
}

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  border: "1px solid #ced4da",
  borderRadius: 8,
  marginTop: 6,
};

const clearButtonStyle = {
  background: "#fff",
  border: "1px solid #ced4da",
  padding: "8px 14px",
  borderRadius: 8,
  cursor: "pointer",
};

const applyButtonStyle = {
  background: "#0d6efd",
  color: "#fff",
  border: "none",
  padding: "8px 14px",
  borderRadius: 8,
  cursor: "pointer",
};